<template>
  <div class="row">
    <div class="col-2"></div>
    <div class="col-8">
      <div class="d-flex justify-content-start">
        <div>
          <font-awesome-icon :icon="['fas', 'circle']" />
        </div>
        <div>課程請假</div>
      </div>
      <hr />
      <div class="d-flex">
        <div>親愛的學員</div>
      </div>
      <div class="d-flex">
        <div>如您無法出席該堂課程，請利用下方表單提出申請請假。</div>
      </div>
      <div class="row text-left">
        <div class="col-12">學員請假守則：</div>
        <ol>
          <li>受理期限：至晚須於該堂課程前一日提出申請(不接受當日請假)。</li>
          <li>申請現場/線上補課限制：請假時數不得超過當期/梯次課程全部時數之1/3(如請假超過全課程1/3之時數部分，不得再申請現場/線上補課)。</li>
          <li>本課程無提供補課機制，除經中心同意以空位安排補課之科目，中心將待後期各梯次釋出請假空位後，依照您申請之請假順位排隊等候補課，並將於排到補課同時致電通知。</li>
        </ol>
      </div>
      <div class="row text-left">
        <div class="col-12">*欲申請補課需求之學員，請填寫下方之請假申請表：</div>
      </div>
      <hr />
      <div class="row text-left">
        <div class="col-12">
          *如須請假兩天以上，請在填寫日期時，點擊按鈕
          <button type="button" class="btn btn-primary">+</button> 增加新日期
        </div>
      </div>
      <div class="form-group row">
        <label for="inputName" class="col-2 text-right col-form-label">學員姓名</label>
        <div class="col-10 text-left">
          <input type="text" class="form-control" id="inputName" />
          <small>若您購買課程的訂購人與上課學員不同，請填寫上課學員姓名</small>
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail" class="col-2 text-right col-form-label">Email</label>
        <div class="col-10 text-left">
          <input type="email" class="form-control" id="inputEmail" />
          <small>請填寫常用的電子信箱</small>
        </div>
      </div>
      <div class="form-group row">
        <label for="inputPhone" class="col-2 text-right col-form-label">聯絡電話</label>
        <div class="col-10 text-left">
          <input type="tel" class="form-control" id="inputPhone" />
          <small>請依據報名資料填寫手機號碼</small>
        </div>
      </div>
      <div class="form-group row">
        <label for="selectCourse" class="col-2 text-right col-form-label">課程名稱</label>
        <div class="col-10 text-left">
          <b-form-select class="form-control" id="selectCourse"></b-form-select>
          <small>選擇您要請假的課程</small>
        </div>
      </div>
      <div class="row">
        <div class="col-2 text-right mt-2">請假日期</div>
        <div class="col-10">
          <div v-for="(item, index) in countDate.length" :key="index">
            <div class="row mt-2">
              <div class="col-4 text-left">
                <b-form-select class="form-control"></b-form-select>
              </div>
              <div class="col-4 text-left">
                <b-form-select class="form-control"></b-form-select>
              </div>
              <button
                v-if="index === (countDate.length - 1)"
                type="button"
                class="btn btn-primary"
                @click="addCount()"
              >+</button>
              <button
                v-if="index !== (countDate.length - 1)"
                type="button"
                class="btn btn-primary"
                @click="lessCount(index)"
              >-</button>
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-for="(item, index) in countDate.length" :key="index">
        <div class="form-group row">
          <label for="leaveDate" class="col-2 text-right col-form-label">請假日期</label>
          <div class="col-4 text-left">
            <b-form-select class="form-control" id="leaveDate"></b-form-select>
          </div>
          <div class="col-4 text-left">
            <b-form-select class="form-control" id="inputPhone"></b-form-select>
          </div>
          <button type="button" class="btn btn-primary" @click="addCount()">+</button>
        </div>
      </div>-->
      <div class="form-group row pt-2">
        <label for="leaveMsg" class="col-2 text-right col-form-label">請假事由</label>
        <div class="col-10">
          <b-form-textarea id="leaveMsg" placeholder="請填寫您的請假原因" rows="4"></b-form-textarea>
          <small>(※若您輸入資料與訂單不符則無法請假成功，請送出資料前再三確認！)</small>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <button type="button" class="btn btn-primary">送出</button>
        <button type="button" class="btn btn-primary">清除</button>
      </div>
    </div>
    <div class="col-2"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      countDate: [''],
    };
  },
  methods: {
    addCount() {
      this.countDate.push('');
    },
    lessCount(index) {
      this.countDate.splice(index, 1);
    },
  },
};
</script>

<style>
</style>
